import { useCallback } from 'react';
import { AddNewWorkspace, WorkspaceMenuMobile } from '../../components/WorkspaceMenu';
import { useUserData } from '../../context';
import { useWorkspaceMenuData } from './useWorkspaceMenuData';
import { StyledPlaceholder } from './DefaultWorkspaceMenu.style';
import { DefaultWorkspaceTrigger } from './DefaultWorkspaceTrigger';

export const DefaultWorkspaceMenuMobile = () => {
  const { getCustomersList, setSearchTerm, items, currentCustomer, setCurrentCustomerId } = useWorkspaceMenuData();
  const { userData: user } = useUserData();
  const onOpenChange = useCallback(
    (isOpen: boolean) => {
      if (isOpen) {
        getCustomersList();
      }
    },
    [getCustomersList]
  );

  return (
    <>
      {currentCustomer ? (
        <WorkspaceMenuMobile
          trigger={<DefaultWorkspaceTrigger customHeight="35px" />}
          items={items}
          defaultSelectedId={currentCustomer.externalId}
          onSelect={setCurrentCustomerId}
          onSearchTermChange={setSearchTerm}
          footerItem={user?.isMasterAdmin && <AddNewWorkspace isMobile={true} />}
          onOpenChange={onOpenChange}
        />
      ) : (
        <StyledPlaceholder />
      )}
    </>
  );
};
